import Paginate from 'vuejs-paginate'
import LayoutMain from './../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../ProgressHUD/index.vue'
import ProjectItem from './../ProjectItem/index.vue'
import Api from './../../../services/api'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Paginate,
    ProjectItem,
  },
  mounted() {},
  data() {
    return {
      projects: null,
      pageNumber: null,
      itemCount: 9,
      rowCount: 3,
      pageCount: null,
      validationMessage: '',
      search: {
        text: '',
        country: '',
        city: '',
        type: 'all',
        numberPage: 1,
        countPages: 1,
        limit: 9,
        my: false,
        cc: false,
      },
      countries: "",
    }
  },
  watch: {
    $route() {
      this.search.text = this.$route.query.text || ''
      this.search.country = this.$route.query.country || ''
      this.search.city = this.$route.query.city || ''
      this.search.type = this.$route.query.type || 'all'
      this.search.cc = this.$route.query.cc || false
      this.search.numberPage = +this.$route.query.page || 1
      this.search.my = this.$route.query.my || false
       
      this.refreshDisplayProjects()
    },
  },
  methods: {
    changePage(numberPage) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: numberPage,
        }),
      })
    },
    searchClick() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          text: this.search.text,
          country: this.search.country,
          city: this.search.city,
        }),
      })
    },
    searchClick2() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          country: this.search.country,
        }),
      })
    },
    searchCbxClick() {
      this.search.cc = !this.search.cc;
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          cc: this.search.cc,
        }),
      })
    },
    async refreshDisplayProjects() {
      try {
        this.$refs.progress.show()
        var response = await Api.getProjects(this.search)
        this.projects = response.data.results
        this.search.countPages = response.data.pagination.countPages
      } catch (error) {
        console.error(error)
        alert(error.message)
      } finally {
        this.$refs.progress.hide()
      }
    },
  },
  async created() {
    this.countries = require('./../../../data/country.js')

    this.search.text = this.$route.query.text || ''    
    this.search.country = this.$route.query.country || ''
    this.search.city = this.$route.query.city || ''
    this.search.type = this.$route.query.type || 'all'
    this.search.numberPage = +this.$route.query.page || 1
    this.search.limit = 20
    this.search.my = this.$route.query.my || false 

    this.$nextTick().then(() => this.refreshDisplayProjects())
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/ProjectsPublic/ProjectsPublic.component.js